import React, { createContext, useState, useEffect } from "react";
import translations from "../translations";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
	const [language, setLanguage] = useState("en");

	useEffect(() => {
		const savedLanguage = localStorage.getItem("language");
		if (savedLanguage && translations[savedLanguage]) {
			setLanguage(savedLanguage);
		}
	}, []);

	useEffect(() => {
		localStorage.setItem("language", language);

		document.documentElement.lang = language;

		const isRTL = ["ar", "he", "fa", "ur"].includes(language);
		document.documentElement.dir = isRTL ? "rtl" : "ltr";

		if (isRTL) {
			document.body.classList.add("rtl");
		} else {
			document.body.classList.remove("rtl");
		}
	}, [language]);

	const t = (key) => {
		if (!key) return "";

		const keys = key.split(".");
		let value = translations[language] || translations.en;

		for (const k of keys) {
			if (!value || typeof value !== "object" || !(k in value)) {
				value = translations.en;

				for (const fallbackKey of keys) {
					if (!value || typeof value !== "object" || !(fallbackKey in value)) {
						return key;
					}
					value = value[fallbackKey];
				}

				return value;
			}
			value = value[k];
		}

		return value;
	};

	const changeLanguage = (lang) => {
		if (translations[lang]) {
			setLanguage(lang);
		}
	};

	const isRTL = ["ar", "he", "fa", "ur"].includes(language);

	return (
		<LanguageContext.Provider value={{ language, changeLanguage, t, isRTL }}>
			{children}
		</LanguageContext.Provider>
	);
};

export default LanguageContext;
